module.exports = {"create_costs_informs":"Crear informe de costes","date_range":"Rango de fechas","inform_name":"Nombre del informe","model_device":"Modelo Disp.","select_model":"Elige Modelo","device":"Dispositivo","create":"Crear","costs_inform":"Informe de costes"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/CostsInform.json
// module id = 599
// module chunks = 1